<template>
    <div class="m15" ref="body" style="page-break-before: always;">

        <div>

            <div style='margin: 0 auto; ' v-if="exibe === true">
                <div class="col l3"></div>
                <div class="col l6 s12">
                    <div style="text-align:center;">
                        <!-- <pie-chart ref="barchat" :myData="datachart" :myLabel="labelchart"/> -->
                        <!-- <pie-chart2 ref="barchat" :myData="datachart2" /> -->
                        <apexcharts
                        v-if="mostra === true"
                        ref="barchart"
                        width="100%"
                        height="200"
                        type="bar"
                        :options="options"
                        :series="options.series"
                        ></apexcharts>
                    </div>
                    <div class="block" style="margin-top:15px;margin-bottom:15px;" v-if="mostra === true">
                        <div align="center">Padrão de Vida Atual</div>
                        <div class="total" align="center">Total: {{this.saldo}}</div>
                    </div>
                </div>
                <div class="col l3"></div>
            </div>
            <div class="row" v-if="exibe === true">
                <div class="col l12 s12">
                    <div class="row" v-if="mostra">
                    <div class="texto" style="text-align:justify">
                        Para que a <b style="font-weight:bold;">manutenção do padrão de vida</b> de seus <b style="font-weight:bold;">dependentes financeiros</b>, mantendo, independente da sua presença física, o acesso à mesma <b style="font-weight:bold;">moradia, alimentação, educação, saúde</b>, é necessário a cobertura de {{this.cobertura}} ({{this.cobertura_extenso}}) mensais, correspondente aos {{this.porcentagem}}% de sua responsabilidade.
                    </div>
                    </div>
                    <div class="row" v-if="anos">
                        <div class="texto" style="text-align:justify">
                            Projetando a necessidade dessa cobertura pelo prazo estimado por você, para essa proteção, por {{this.anos}} ano(s), o montante necessário de cobertura é de {{this.montante}} ({{this.montante_extenso}}).
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ApexCharts from 'apexcharts'
    import VueApexchar from 'vue-apexcharts'
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    import PieChart from '@/components/canvas-chart/PieChart'
    import PieChart2 from '@/components/canvas-chart/PieChart2'
    import Saudacao from './Saudacao'
    const extenso = require('extenso')
    export default {
        name:'Responsabilidade',
        mixins:[utils],
        components: {
            PieChart,
            PieChart2,
            'apexcharts': VueApexchar,
            Saudacao
        },
        data () {
            return {
                db: [],
                options: {},
                image:null,
                saldo:null,
                porcentagem: null,
                extenso: null,
                cobertura: null,
                cobertura_extenso: null,
                anos: null,
                montante: null,
                montante_extenso: null,
                padrao_vida:[],
                exibe: false,
                mostra: false,
                datachart: [],
                datachart2: [],
                labelchart: [],
                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=',
            }
        },
        props: {
            cliente: Object,
        },
        methods:{
            async plot(){

                // if (! this.$refs.barchat) return '';

                // const canvas = this.$refs.barchat.chart;

                // if (canvas) {
                //    this.image = canvas.toDataURL("image/png");
                // }

                if(this.$refs.barchart){
                    await this.$refs.barchart.chart.dataURI().then(uri => {
                        this.image = uri;
                    });
                }

                if (this.exibe === true){
                return `<div ref="body">
                        <div class="grafico">
                        <div class="row">
                            <img src="${this.image}" />
                        </div>
                        </div>
                        <div class="row" style="padding-top: 20px;">
                           <table>
                                <tr>
                                    <td width="100%" style="vertical-align: top;">
                                        <p style="font-size:18px;padding-bottom:20px;">
                                            Para que a <b style="font-weight:bold;">manutenção do padrão de vida</b> de seus <b style="font-weight:bold;">&nbsp;dependentes financeiros</b>, mantendo, independente da sua presença física, o acesso à mesma <b style="font-weight:bold;">moradia, alimentação, educação, saúde</b>, é necessário a cobertura de ${this.cobertura} (${this.cobertura_extenso}) mensais, correspondente aos ${this.porcentagem}% de sua responsabilidade.
                                        </p>

                                        <p style="font-size:18px;padding-bottom:20px; display: ${this.anos ? 'block' : 'none'}">
                                            Projetando a necessidade dessa cobertura pelo prazo estimado por você, para essa proteção, por ${this.anos} ano(s), o montante necessário de cobertura é de ${this.montante} (${this.montante_extenso}).
                                        </p>
                                    </td>
                                </tr>
                           </table>
                        </div>
                    </div>`;
                } else {
                    return ''
                }
            },

            jsonToObject(j){
                return Object.keys(j).map(function(_) { return j[_]; })
            },

            readyData(...val){
                let params = val
                this.options = {
                    chart: {
                        width: "100%",
                        height: 350,
                        type: 'bar',
                        stacked: true,
                        stackType: '100%',
                        animations: {
                            enabled: false
                        },
                        toolbar:{
                            show:false,
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true
                        }
                    },
                    stroke: {
                    width: 1,
                    colors: ['#fff']
                    },
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'left',
                        style: {
                            fontSize: '13px',
                            colors: ['#000']
                        },
                        dropShadow: {
                            enabled: false
                        }
                    },
                    series: [{
                        name:params.map(item =>  item.name)[0],
                        data:[params.map(item =>  item.value)[0]]
                    },
                    {
                        name:params.map(item =>  item.name)[1],
                        data:[params.map(item =>  item.value)[1]]
                    }],
                    grid: {
                        row: {
                            colors: ['#fff']
                        }
                    },
                    colors: ['#52dfec','#a3a0fb'],
                    xaxis: {
                        categories: ['Total'],
                        labels: {
                            formatter: function(val){
                                return val+'%'
                            }
                        }
                    },
                    legend: {
                        fontSize: '14px',
                    },
                    theme: {
                        mode: 'light',
                        palette: 'palette1'
                    },
                    tooltip:{
                        theme:'light'

                    },
                    responsive: [{
                        breakpoint: 1000,
                        options: {
                            legend: {
                                position: "bottom"
                            }
                        }
                    },
                    {
                        breakpoint: 380,
                        options:{
                            plotOptions: {
                                bar: {
                                    horizontal: true
                                }
                            },
                            legend: {
                                position: "bottom"
                            },
                        }
                    }]
                }
            },

            async getData(){

                const {padrao_vida} = this.cliente;

                if(padrao_vida != null){
                    this.padrao_vida = this.jsonToObject(padrao_vida)
                }  else {
                    return;
                }


                const gastos_fixos = padrao_vida.gastos_fixos || 0;
                const lazer = padrao_vida.lazer || 0;
                const seguros = padrao_vida.seguro_previdencia || 0;
                const outros = padrao_vida.outros || 0;

                const porcentagem = padrao_vida.porcentagem_responsabilidade || 0;
                const anos = padrao_vida.anos_protecao_familia;

                const montante = padrao_vida.valor_total;

                const percent = porcentagem / 100;

                const total = gastos_fixos + lazer + seguros + outros;

                const sua_resposabilidade = parseFloat(total * percent);
                const terceiros = parseFloat(total - sua_resposabilidade);



                if(
                    sua_resposabilidade === 0 ||
                    porcentagem === 100
                ){
                    this.exibe = false;
                }else{
                    this.exibe = true;
                }

                console.log({porcentagem})

                if(padrao_vida != null){
                    this.saldo = this.real(this.total(gastos_fixos, lazer, seguros, outros))
                    this.porcentagem = porcentagem
                    this.cobertura = this.real(this.total(gastos_fixos, lazer, seguros, outros) * percent)
                    this.cobertura_extenso = this.currency(this.total(gastos_fixos, lazer, seguros, outros) * percent)
                    this.extenso = extenso(porcentagem)
                    this.anos = anos
                    this.montante = this.real(montante)
                    this.montante_extenso = this.currency(montante)
                    this.db.push(gastos_fixos, lazer, seguros, outros)

                    const data = [
                        {name: 'Sua\nResponsabilidade', value: sua_resposabilidade},
                        {name: 'Responsab\n3º', value: terceiros}
                    ].filter(item => item.value !== 0)

                    const data2 = [
                        {label: 'Sua\nResponsabilidade', value: sua_resposabilidade},
                        {label: 'Responsabilidade\n3º', value: terceiros}
                    ].filter(item => item.value !== 0)

                    this.labelchart = data.map(item => item.name)

                    this.datachart = data.map(item => item.value)

                    this.datachart2 = data2.reverse()

                    this.show(sua_resposabilidade, terceiros)
                    this.readyData(
                        {name: 'Sua\nResponsabilidade', value: sua_resposabilidade.toFixed(2)},
                        {name: 'Responsabilidade\n3º', value: terceiros.toFixed(2)}
                    )
                }

                if(sua_resposabilidade === 0 || porcentagem === 100){
                    this.mostra = false;
                }else{
                    this.mostra = true;
                }

            },

            show (...args) {

                if (!args) return

                const diff = args.filter(item => item !== 0)
                if (diff.length === 0) {
                    this.mostra = false
                }
                if (diff.length === 1) {
                    this.mostra = false
                }
                if (diff.length > 1) {
                    this.mostra = true
                }
            },
        },
        mounted () {
            this.getData()
        }
    }
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";
.graph{
    text-align: center;
}
.total{
    font-size: 12px;
}
.block{
    width: 300px;
    display: block;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
.p30{
    padding: 30px;
}
@media (min-width: 320px) and (max-width: 480px) {
   .block{
        width: 300px;
    }
}
@media (min-width: 768px) and (max-width:938px){
    .block{

    }
}
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/Responsabilidade.vue